export const DEFAULT_AWARD_IMAGE =
    'https://firebasestorage.googleapis.com/v0/b/dev-as-cv.appspot.com/o/certifications-img.png?alt=media&token=0471c53d-bea2-4ef0-ba51-d45ee22fb669';
